// // import React from 'react';
// // import {
// //   Card,
// //   CardContent,
// //   Typography,
// //   Table,
// //   TableBody,
// //   TableRow,
// //   TableCell,
// //   Box,
// // } from '@mui/material';

// // const jobRoles = [
// //   ['Fashion Designer', 'Textile Designer', 'Knitwear Designer','Merchandiser', 'Quality Control Manager', 'Production Manager','Merchandiser', 'Quality Control Manager', 'Production Manager'],
// //   ['Merchandiser', 'Quality Control Manager', 'Production Manager'],
// //   ['Accessory Designer', 'Leather Designer', 'Fashion Communication'],
// //   ['Graphic Designer', 'Print Designer', 'UI/UX Designer'],
// //   ['Others', '', ''],
// // ];

// // const SearchJobVacancy = () => {
// //   return (
// //     <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}>
// //       <Card sx={{ width: '90%', maxWidth: 1000, boxShadow: 3 }}>
// //         <CardContent>
// //           <Typography
// //             variant="h5"
// //             component="div"
// //             sx={{ fontWeight: 'bold', mb: 2 }}
// //           >
// //             Job Vacancy Details
// //           </Typography>
// //           <Table>
// //             <TableBody>
// //               {jobRoles.map((row, rowIndex) => (
// //                 <TableRow key={rowIndex}>
// //                   {row.map((role, colIndex) => (
// //                     <TableCell
// //                       key={colIndex}
// //                       sx={{
// //                         textAlign: 'center',
// //                         fontWeight: 500,
// //                         borderRight: colIndex < 2 ? '1px solid #e0e0e0' : '',
// //                         borderBottom:
// //                           rowIndex < jobRoles.length - 1
// //                             ? '1px solid #e0e0e0'
// //                             : '',
// //                       }}
// //                     >
// //                       {role}
// //                     </TableCell>
// //                   ))}
// //                 </TableRow>
// //               ))}
// //             </TableBody>
// //           </Table>
// //         </CardContent>
// //       </Card>
// //     </Box>
// //   );
// // };

// // export default SearchJobVacancy;


// import React from 'react';
// import {
//   Card,
//   CardContent,
//   Typography,
//   Table,
//   TableBody,
//   TableRow,
//   TableCell,
//   Box,
// } from '@mui/material';

// const jobRoles = [
//   ['Fashion Designer', 'Textile Designer', 'Knitwear Designer','Merchandiser', 'Quality Control Manager', 'Production Manager','Merchandiser', 'Quality Control Manager', 'Production Manager'],
// ];

// const SearchJobVacancy = () => {
//   return (
//     <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}>
//       <Card sx={{ width: '90%', maxWidth: 1000, boxShadow: 3 }}>
//         <CardContent>
//           <Typography
//             variant="h5"
//             component="div"
//             sx={{ fontWeight: 'bold', mb: 2 }}
//           >
//             Job Vacancy Details
//           </Typography>
//           <Table>
//             <TableBody>
//               {jobRoles.map((row, rowIndex) => (
//                 <TableRow key={rowIndex}>
//                   {row.map((role, colIndex) => (
//                     <TableCell
//                       key={colIndex}
//                       sx={{
//                         textAlign: 'center',
//                         fontWeight: 500,
//                         borderRight: colIndex < 2 ? '1px solid #e0e0e0' : '',
//                         borderBottom:
//                           rowIndex < jobRoles.length - 1
//                             ? '1px solid #e0e0e0'
//                             : '',
//                       }}
//                     >
//                       {role}
//                     </TableCell>
//                   ))}
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };

// export default SearchJobVacancy;


import React from 'react';
import {
    Card,
    CardContent,
    Typography,
    Table,
    TableBody,
    TableRow,
    TableCell,
    Box,
    Divider,
} from '@mui/material';

// Helper to chunk array into groups of 3
const chunkArray = (array, size) => {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
        result.push(array.slice(i, i + size));
    }
    return result;
};

const jobTitles = [
    'Fashion Designer',
    'Textile Designer',
    'Knitwear Designer',
    'Merchandiser',
    'Quality Control Manager',
    'Production Manager',
    'Accessory Designer',
    'Leather Designer',
    'Fashion Communication',
    'Graphic Designer',
    'Print Designer',
    'UI/UX Designer',
    'Others',
];

const SearchJobVacancy = () => {
    const jobRoles = chunkArray(jobTitles, 3); // split into rows of 3

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}>
            <Card sx={{ width: '90%', maxWidth: 1000, boxShadow: 3 }}>
                <CardContent>
                    <Typography variant="h6" gutterBottom>Job Vacancy Details</Typography>
                    <Divider />
                    <Table sx={{mt:2}}>
                        <TableBody>
                            {jobRoles.map((row, rowIndex) => (
                                <TableRow key={rowIndex}>
                                    {row.map((role, colIndex) => (
                                        <TableCell
                                            key={colIndex}
                                            sx={{
                                                textAlign: 'center',
                                                fontWeight: 500,
                                                background: rowIndex % 2 !== 0 ? "rgb(249 248 248)" : "white",
                                                // borderRight: colIndex < 2 ? '1px solid #e0e0e0' : '',
                                                border: '1px solid #e0e0e0',

                                                // borderBottom:
                                                //   rowIndex < jobRoles.length - 1
                                                //     ? '1px solid #e0e0e0'
                                                //     : '',
                                            }}
                                        >
                                        
                                        <Typography variant='customText' sx={{color:"black"}}>{role}</Typography>
                                            
                                        </TableCell>
                                    ))}
                                    {/* Fill empty cells if row has less than 3 items */}
                                    {row.length < 3 &&
                                        Array.from({ length: 3 - row.length }).map((_, i) => (
                                            <TableCell key={`empty-${i}`} />
                                        ))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </CardContent>
            </Card>
        </Box>
    );
};

export default SearchJobVacancy;
